import Add20 from '@carbon/icons-react/es/add/20';
import Menu16 from '@carbon/icons-react/es/menu/16';
import { Tooltip } from 'antd';
import React, { FC, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import { TertiaryButton } from 'components/atoms/tertiary-button';
import { Page } from 'components/molecules/page';
import { HoverableLinkButton } from 'components/molecules/views/components';
import { getNewWidgetUrl } from 'utils/urls';
import {
  DashboardModal,
  DashboardModelVariant,
  useDashboardManageModal,
} from '../dashboard-modal';
// eslint-disable-next-line import/no-internal-modules
import { DashboardNav } from '../dashboard-nav/nav';
import { useDashboardInfo } from '../useDashboardInfo';

const HeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: 'space-between';
  gap: 16px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 16px;

  ${HoverableLinkButton} {
    border-color: var(--primary-color);
  }
`;

export const DashboardHeader: FC = () => {
  const {
    variant,
    modalActions: { setModalClose, setModalOpen },
    modalProps,
  } = useDashboardManageModal();
  const {
    selectedDashboard: { selectedTitle, selectedId },
  } = useDashboardInfo();
  const [showSlider, setShowSlider] = useState(false);
  const { search } = useLocation();

  return (
    <>
      <ButtonWrapper>
        <Tooltip title={<FormattedMessage id="dashboard.switch_dashboard" />}>
          <HoverableLinkButton
            data-cy="buttons.views-sider-open"
            icon={<Menu16 />}
            onClick={() => setShowSlider(true)}
          />
        </Tooltip>
        <DashboardNav isShown={showSlider} setShown={setShowSlider} />
      </ButtonWrapper>
      <HeaderContent>
        <Page.Header.Title>{selectedTitle}</Page.Header.Title>
        <Wrapper>
          <TertiaryButton
            iconPlacement="right"
            data-cy="dashboard.add-dashboard"
            icon={<Add20 />}
            onClick={() => setModalOpen(DashboardModelVariant.Create)}
          >
            <FormattedMessage id="dashboard.new_dashboard" />
          </TertiaryButton>
          <Link to={getNewWidgetUrl(selectedId, search)}>
            <Button
              type="primary"
              iconPlacement="right"
              icon={<Add20 />}
              data-cy="dashboard.add-widget"
            >
              <FormattedMessage id="dashboard.new_chart" />
            </Button>
          </Link>
        </Wrapper>
      </HeaderContent>
      <DashboardModal
        variant={variant}
        onClose={setModalClose}
        {...modalProps}
      />
    </>
  );
};
